import { useEffect, useState } from 'react';
import Icon from '../../Atoms/Icon/Icon';
import bem from '../../../utils/bem';
import Select from '../../Atoms/FormComponents/Select';
import { useAnalyticsPushEvent } from '../../../analytic/analytic.context';

const Pager = ({ analyticData, meta, changePage, itemsPerPage = null }) => {
  const baseClass = 'pager';
  const { pageNumber: currentPage, totalPages } = meta || {};
  const [pages, setPages] = useState([]);
  const pushAnalyticEvent = useAnalyticsPushEvent();

  useEffect(() => {
    if (typeof currentPage === 'number') {
      let range = [...Array(totalPages + 1).keys()];

      if (range.length > 5) {
        let start = 0;
        if (currentPage > 1) {
          if (currentPage > totalPages - 2) {
            start = totalPages - 4;
          } else {
            start = currentPage - 2;
          }
        }
        range = range.slice(start, start + 5);
      }
      setPages(range);
    }
  }, [currentPage, totalPages]);

  if ((!meta && currentPage < 2) || totalPages < 2) {
    return '';
  }

  const changePageHandler = (page, event) => {
    changePage(page, event);

    // Push data to dataLayer on page number change.
    if (analyticData) {
      const searchTerm = analyticData.searchTerm
        ? analyticData.searchTerm
        : null;

      pushAnalyticEvent({
        event: 'pagination_selected',
        event_origin: 'front_end',
        number_of_results: page + 1,
        content_type: analyticData.listingType,
        search_term: searchTerm,
      });
    }
  };

  const renderPrevButton = () => {
    if (currentPage < 1) {
      return '';
    }

    return (
      <li className={bem('item', ['prev'], baseClass)}>
        <button
          className="btn-icon"
          title={Drupal.t('Go to previous page')}
          onClick={(e) => changePageHandler(currentPage - 1, e)}
        >
          <span className="visually-hidden">{Drupal.t('Previous page')}</span>
          <Icon iconName="arrow" />
        </button>
      </li>
    );
  };

  const pageItem = (number) => {
    let visuallyHiddenText = `${Drupal.t('Go to page')} `;

    if (currentPage === number) {
      visuallyHiddenText = Drupal.t('Current page');
    }

    return (
      <li
        className={bem('item', [], baseClass, [
          `${currentPage === number ? 'is-active' : ''}`,
        ])}
        key={number}
      >
        <button
          className="btn-clear"
          onClick={(e) => changePageHandler(number, e)}
        >
          <span className="visually-hidden">{visuallyHiddenText}</span>
          {number + 1}
        </button>
      </li>
    );
  };

  const renderPageButtons = () => {
    return pages.map((page) => {
      return page + 1 > totalPages ? '' : pageItem(page);
    });
  };

  const renderNextButton = () => {
    if (currentPage + 1 === totalPages) {
      return '';
    }

    return (
      <li className={bem('item', ['next'], baseClass)}>
        <button
          className="btn-icon"
          title={Drupal.t('Go to next page')}
          onClick={(e) => changePageHandler(currentPage + 1, e)}
        >
          <span className="visually-hidden">{Drupal.t('Next page')}</span>
          <Icon iconName="arrow" />
        </button>
      </li>
    );
  };

  const renderElipsesPrev = () => {
    if (currentPage < 3) {
      return '';
    }
    return (
      <li className={bem('item', ['ellipsis'], baseClass)}>
        <span>...</span>
      </li>
    );
  };

  const renderElipsesNext = () => {
    if (currentPage + 3 === totalPages) {
      return '';
    }
    return (
      <li className={bem('item', ['ellipsis'], baseClass)}>
        <span>...</span>
      </li>
    );
  };

  return (
    <div className="pager-wrapper">
      <nav className={bem(baseClass)} role="navigation">
        <ul className={bem('items', [], baseClass, ['flex', 'justify-center'])}>
          {renderPrevButton()}
          {renderElipsesPrev()}
          {renderPageButtons()}
          {renderElipsesNext()}
          {renderNextButton()}
        </ul>
      </nav>
      {itemsPerPage ? (
        <Select
          settings={itemsPerPage.settings}
          onChange={itemsPerPage.onChange}
        />
      ) : (
        ''
      )}
    </div>
  );
};

export default Pager;
